import React,{useState,useEffect} from 'react'
import SubHeader from '../../layout/components/SubHeader'
import dasbhoardService from '../../../services/dashboard.service'
import { useEyeconxStore } from '../../../store/eyeconxStore'
import clinicService from '../../../services/clinic.service'
import Loading from '../../common/Loading'

function Dashboard() {
   const user = useEyeconxStore(state=>state.user)
   const setTodaysAppointment = useEyeconxStore(state=>state.setTodaysAppointment)
   const userInfo = useEyeconxStore(state=>state.userInfo)
   const setUserInfo = useEyeconxStore(state=>state.setUserInfo)



   useEffect(()=>{
    getAppointments()
    //if userinfo object is set then do nothing else call getuserinfo
   
   },[])

   const getAppointments =()=>{
    dasbhoardService.getAppointment(user.clinicId)
      .then(res=>{
        setTodaysAppointment(res.data)
        //console.log("Appointment Data")
        //console.log(res.data)
       })
       .catch(err=>{
        console.log(err)
       })
   }
  
  return (
    <>
        <SubHeader title="Dashboard" description={"Eyes On Sheppard | 500 Mb | 120 items"}/>
        <div className='app-container bg-dark'>
              Dashbard content
        </div>
    </>
  )
}

export default Dashboard